import { Text } from '$components'
import dayjs from 'dayjs'
import { memo } from 'react'

export type TimeProps = {
  start_at: string
  finish_at: string
}

export const Time = memo(function Time({ start_at, finish_at }: TimeProps) {
  return (
    <Text
      type="xs"
      className="text-fg-subtle"
    >
      {dayjs.utc(start_at).format('HH:mm A')} - {dayjs.utc(finish_at).format('HH:mm A')}
    </Text>
  )
})
